import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
import Cookies from 'js-cookie';

import styles from "./SelectSite.module.scss";

import WelcomePanel from "../components/WelcomePanel/WelcomePanel";
import FormElement from "components/FormElement/FormElement";
import Select from "components/Select/Select";
import SelectAlt from "components/SelectAlt/SelectAlt";
import { connect } from "react-redux";
import { toggleDropdowns } from "helpers/utils";
import Button from "components/Button/Button";
import logo from "assets/img/compliancy-group-logo.png";

import { loadUserOrgSiteAction, authGetUserAction } from "store/actions/Actions";

const SelectSite = props => {
    const { UserOrgSiteReducer, AuthReducer, loadUserOrgSiteAction, 
        // authGetUserAction
    } = props;
    const [orgs, setOrgs] = useState({});
    const [sites, setSites] = useState({});
    const [selected_org, setSelectedOrg] = useState("");
    const [selected_site, setSelectedSite] = useState("");
    const [stateErrors, setStateErrors] = useState({});
    // const history = useHistory();

    useEffect(() => {
        loadUserOrgSiteAction();
    }, [loadUserOrgSiteAction]);

    useEffect(() => {
        if (UserOrgSiteReducer.organizations) {
            setOrgs(UserOrgSiteReducer.organizations);
        }
    }, [UserOrgSiteReducer.organizations, UserOrgSiteReducer.selected]);

    let selected_roles = {};
    if (AuthReducer.userData && AuthReducer.userData.role) {
        AuthReducer.userData.role.forEach(role => {
            if (role.organization === `${selected_org}`) {
                selected_roles = role;
                if (role.site !== "*" && selected_site) {
                    if (role.site === `${selected_site}`) {
                        selected_roles = role;
                    }
                }
                if (role.site === "*") {
                    selected_roles = role;
                    selected_roles.is_org_admin = "t";
                }
            }
        });    
    }

    const is_officer = selected_roles.is_officer === "t" ? true : false;
    const is_super = selected_roles.is_super === "t" ? true : false;
    const is_org_admin = selected_roles.is_org_admin === "t" ? true : false;
    const selectSiteDropdownToggleRef = React.createRef();
    const selectOrgDropdownToggleRef = React.createRef();

    const handleOrgSelect = (e) => {
        try {
            if (e.target.value) {
                setSelectedOrg(e.target.value);
                setSites(orgs[e.target.value].sites);
                setStateErrors((s) => ({ ...s, org: '', site: '' }));    
            }
        } catch (error) {
            console.log('error with org select');
        }
    }

    useEffect(() => {
        setSelectedSite(() => selected_org && (is_officer || is_super || is_org_admin) ? 0 : "");
    }, [selected_org, is_officer, is_super, is_org_admin]);

    const handleSiteSelect = (e) => {
        try {
            setSelectedSite(e.target.value);
            setStateErrors((s) => ({ ...s, site: '' }));
        } catch (error) {
            console.log('error with site select');
        }
    }

    const handleLogin = () => {

        // set cookies
        if (selected_org === "") {
            setStateErrors((s) => ({ ...s, org: 'Please, select Organization!' }));
        }
        if (selected_site === "") {
            setStateErrors((s) => ({ ...s, site: 'Please, select Site!' }));
        }

        if (selected_site !== "" && selected_org !== "") {
            Cookies.set('org', selected_org);
            if (selected_site !== 0) {
                Cookies.set('site', selected_site);
            } else {
                Cookies.remove('site');
            }

            if (props.match.params && props.match.params.hash && props.match.params.hash.trim()) {
                let link = window.atob(props.match.params.hash);
                window.location.href = '/'+link;
            } else {
                window.location.href = '/';
            }
            // authGetUserAction();
            // history.replace('/');
        }
    }

    const orgsList = {};
    Object.keys(orgs).forEach((key, index) => {
        orgsList[key] = orgs[key].name;
    });

    const sitesList = {};
    sitesList[0] = (is_officer || is_super || is_org_admin) && selected_org ? "All" : "";
    Object.keys(sites).forEach((key, index) => {
        if (sites[key].active === "t") {
            sitesList[key] = sites[key].name;
        }
    });

    const sortedOrgs = Object.keys(orgs).map((key, index) => ({ ...orgs[key], id: key })).sort((a, b) => (a.name > b.name ? 1 : -1));
    const sortedSites = Object.keys(sites).map((key, index) => ({ ...sites[key], id: key })).sort((a, b) => (a.name > b.name ? 1 : -1));
    return (
        <WelcomePanel type="site-select" onClick={toggleDropdowns([selectSiteDropdownToggleRef, selectOrgDropdownToggleRef])}>
            <div className={styles["login-panel-heading"]}>
                <img className={styles.logo} src={logo} alt="" />
            </div>

            <div className={styles["site-select-panel"]}>
                <p className={styles.welcome}>Welcome to The Guard!</p>
                <FormElement
                    labelText="Organization"
                    htmlFor="org-select"
                    className={styles["form-org-select"]}
                    errorMessage={stateErrors.org}
                >
                    <SelectAlt
                        placeholder="Select Organization"
                        labels={orgsList}
                        showAll={false}
                        // value={selected_org}
                        onClick={handleOrgSelect}
                        dropdownToggleRef={selectOrgDropdownToggleRef}
                    >
                        {/* {Object.keys(orgs).map((key, index) => <li key={`org_id-${key}`} data-id={key} value={key}>{orgs[key].name + ( orgs[key].customer_id ? ' - ' + orgs[key].customer_id: '')}</li>)} */}
                        {sortedOrgs.map((org) => <li key={`org_id-${org.id}`} data-id={org.id} value={org.id}>{org.name + ( org.customer_id ? ' - ' + org.customer_id: '')}</li>)}
                    </SelectAlt>
                </FormElement>

                <FormElement
                    labelText="Site"
                    htmlFor="site-select"
                    className={styles["form-site-select"]}
                    errorMessage={stateErrors.site}
                >
                    <Select
                        placeholder="Select Site"
                        labels={sitesList}
                        value={selected_site}
                        onClick={handleSiteSelect}
                        dropdownToggleRef={selectSiteDropdownToggleRef}
                    >
                        {(is_officer || is_super || is_org_admin) && selected_org ? <li key={`org_id-all`} value="0">All</li> : ""}
                        {/* {Object.keys(sites).map((key, index) => {
                            if (sites[key].active === "t") {
                                return <li key={`sites_id-${key}`} value={key}>{sites[key].name}</li>;
                            }
                        })} */}
                        {sortedSites.filter((s) => s.active === "t").map((site) => <li key={`sites_id-${site.id}`} value={site.id}>{site.name}</li>)}

                    </Select>
                </FormElement>
            </div>
            <div className={styles["login-panel-footer"]}>
                <Button text={"CLICK TO LOGIN"} onClick={handleLogin} />
            </div>
        </WelcomePanel>
    );
};

const mapStateToProps = state => ({
    UserOrgSiteReducer: state.UserOrgSiteReducer,
    AuthReducer: state.AuthReducer,
});

const mapDispatchToProps = {
    loadUserOrgSiteAction,
    authGetUserAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectSite);
